import { unifiedApiKeys } from '@/services/keys';

import type { UnifiedApiParams } from '@/types/mercury-data-types/unifiedapi';

export const sourcesKeys = {
  table: (params?: Partial<UnifiedApiParams>) =>
    ['table', ...unifiedApiKeys.records('/catalog/sources', params)] as const,
};
